jQuery(function ($) {
	//Si se trata de un usuario visitante
	var is_visitor = false;
	if (typeof (rate_params['visitor_cookie_name']) !== "undefined") {
		is_visitor = true;
		//Si no existe, crear una cookie para identificar a los usuarios visitantes
		if (getVisitorCookie() === "") {
			setVisitorCookie();
		}
	}

	$(".rate_post").on("click", function () {

		//Si ya se habia seleccionado una califiacion, eliminarla
		$(this).closest("div.rate-container").find(".rate_post").removeClass("selected")

		//Activar el boton calificado
		$(this).addClass("selected");

		const user_post_rate = $(this).attr("data-value")
		const post_id = $(this).attr("data-post")
		sendRate(post_id, user_post_rate);

		var user_rated = false;//'. $user_rated .';		

		if (user_rated) {
			return true;
		}

		sendRate($(this).attr("data-value"));
	})

	$(".post-like").on("click", function () {
		const post_id = $(this).attr("data-post")

		const next_favorite_value = $(this).attr("data-value") == 1 ? 0 : 1;
		addFavorite(post_id, $(this), next_favorite_value)
	})

	//Agregar o retirar un post como favorito
	function addFavorite(post_id, target, favorite) {
		var user_id = is_visitor ? null : rate_params['user_id'];
		var user_key = is_visitor ? null : rate_params['user_key'];
		var post_id = post_id;
		var session_id = is_visitor ? getVisitorCookie() : null;

		var apiEndpoint = wpData.apiUrl + "module-rate/v1/add-favorite/";

		//Marcar el boton como favorito sin esperar la respuesta del servidor
		if (favorite == 1) {
			$(target).addClass('active');
			$(target).attr('title', $(target).attr('data-remove-title'))
			$(target).attr('data-bs-original-title', $(target).attr('data-remove-title'))
			$(target).tooltip()
			$(target).attr('data-value', 1);
		} else {
			$(target).attr('title', $(target).attr('data-add-title'))
			$(target).attr('data-bs-original-title', $(target).attr('data-add-title'))
			$(target).tooltip()
			$(target).removeClass('active');
			$(target).attr('data-value', 0);
		}

		$.ajax({
			type: "POST",
			url: apiEndpoint,
			data: {
				session_id: session_id,
				user_id: user_id,
				post_id: post_id,
				ptrck_user_key: user_key,
				favorite: favorite
			},
			success: function (data_response) {
				user_content_params['favorites_post_status'] = "not_loaded";
			},
			error: function () {

				//Si hubo un error reversar la marcación del boton
				if (favorite == 1) {
					$(target).removeClass('active');
				} else {
					$(target).addClass('active');
				}
			}
		});
	}

	function sendRate(post_id, rating) {

		var user_id = is_visitor ? null : rate_params['user_id'];
		var user_key = is_visitor ? null : rate_params['user_key'];
		var post_id = post_id;
		var session_id = is_visitor ? getVisitorCookie() : null;

		var apiEndpoint = wpData.apiUrl + "module-rate/v1/rate-post/";

		$.ajax({
			type: "POST",
			url: apiEndpoint,
			data: {
				session_id: session_id,
				user_id: user_id,
				post_id: post_id,
				ptrck_user_key: user_key,
				rating: rating
			},
			success: function (data_response) {
				console.log(data_response);
			},
			error: function () {
			}
		});
	}
});

window.markAsViewed = (post_id) => {
	if (debugReadContent || wpData.debugReadContent) { alert('Contenido visto') }

	let data = {
		session_id: getVisitorCookie(),
		ptrck_user_key:  rate_params['user_key'],
		user_id: rate_params['user_id'],
		post_id: post_id
	}

	$.ajax({
		type: "POST",
		url: wpData.apiUrl + "module-post/v1/read_post",
		data: data,
		success: function (data_response) {
			console.log(data_response);
		},
		error: function () {
		}
	});
}

window.getVisitorCookie = () => {
	const visitor_cookie_name = rate_params['visitor_cookie_name'];

	var name = visitor_cookie_name + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

//Crea una cookie para identificar a los usuarios que no se encuentran logeados
window.setVisitorCookie = () =>  {
	$.getJSON("https://api.ipify.org?format=json", function (data) {
		const session_value = data.ip + "@" + wpData.uniq_id;
		const visitor_cookie_name = rate_params['visitor_cookie_name'];
		const exdays = 90;

		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var expires = "expires=" + d.toUTCString();
		document.cookie = visitor_cookie_name + "=" + session_value + ";" + expires + ";path=/";
	})
}

window.debugReadContent = false;
window.isContentViewed = false;

window.initPodcastContent = (el, postId, podcast) => {
	const podElement = document.getElementById(el);
	const tag = document.createElement('script');
	const firstScriptTag = document.getElementsByTagName('script')[0];

	tag.id = el + '-script';
	tag.src = 'https://open.spotify.com/embed/iframe-api/v1';
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  window.onSpotifyIframeApiReady = (IFrameAPI) => {
    const options = {
      width: '100%',
      height: '232',
      frameBorder: '0',
      allowfullscreen: 'over',
      uri: 'spotify:episode:' + podcast
    };

    const callback = (EmbedController) => {
      EmbedController.addListener('playback_update', e => {
        let duration = parseInt(e.data.duration / 1000, 10);
        let position = parseInt(e.data.position / 1000, 10);
        if (!isContentViewed && position > (duration * 0.90)) {
          isContentViewed = true
          markAsViewed(postId);
        }
      });
    };

    IFrameAPI.createController(podElement, options, callback);
  };
}

window.initVideoContent = (el, postId, videoId) => {
	const tag = document.createElement('script');
	tag.id = el + '-script';
	tag.src = 'https://www.youtube.com/iframe_api';
	const firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

	var player;

	window.onYouTubeIframeAPIReady = () => {
		player = new YT.Player(el, {
			playerVars: {
				'accelerometer': 1, 'autoplay': 1, 'clipboard-write': 1, 'encrypted-media': 1, 
				'gyroscope': 1, 'picture-in-picture': 1,
			},
      videoId: videoId,
			events: { 'onStateChange': onPlayerStateChange }
		});
	}

	window.onPlayerStateChange = (event) => {
		if (!isContentViewed && event.data == YT.PlayerState.ENDED) {
			isContentViewed = true;
			markAsViewed(postId);
		}
	}
}

window.initPostContent = (el, postId, readTime, postHeight) => {
	// Obtener el elemento
	var tiempoCargaPagina = new Date().getTime();

	// Calcular la posición en función del porcentaje (rango: 0-100)
	function calcularPosicion(porcentaje, elemento) {
		// Obtener las dimensiones del elemento
		let alto = elemento.offsetHeight;

		// Calcular la posición en píxeles
		let posicionY = (alto * porcentaje) / 100;

		return { y: posicionY, alto: alto };
	}

	// Función para detectar el desplazamiento
	function handleScroll() {
		// Verifica si el usuario ha alcanzado cierta posición de desplazamiento
		let scrollY = window.pageYOffset || document.documentElement.scrollTop;

		if (!isContentViewed && (scrollY >= c_data.y && scrollY <= (c_data.y + c_data.alto))) {
			let tiempoActual = new Date().getTime();
			let tiempoEstancia = (tiempoActual - tiempoCargaPagina) / 1000;

			if (tiempoEstancia > readTime) {
				isContentViewed = true;
				markAsViewed(postId);
			}
		}
	}

	// Registra el evento de desplazamiento
	window.addEventListener('scroll', handleScroll);

	// Calcular la posición para un porcentaje específico (ejemplo: 50%)
	var c_data = calcularPosicion(postHeight, document.getElementById(el));
}

